module.exports = __webpack_public_path__ + "img/cursor-pointer.2ffb8bdd.svg";